// POLICY LISTING
export const PDF_GENERATION_REQUEST = 'PDF_GENERATION__REQUEST';
export const PDF_GENERATION_SUCCESS = 'PDF_GENERATION__SUCCESS';
export const PDF_GENERATION_FAILURE = 'PDF_GENERATION__FAILURE';


